<template>
    <div class="room" :style="'font-family:' + fontFamily">
        <v-text-field
            v-model="contact.first_name"
            v-if="hasField('CONTACT_FIRST_NAME')"
            :label="getField('CONTACT_FIRST_NAME').name"
            class="mb-4"
            hide-details
            outlined>
        </v-text-field>

        <v-text-field
            v-model="contact.last_name"
            v-if="hasField('CONTACT_LAST_NAME')"
            :label="getField('CONTACT_LAST_NAME').name"
            hide-details
            class="mb-4"
            outlined>
        </v-text-field>

        <v-text-field
            v-model="contact.email"
            v-if="hasField('CONTACT_EMAIL')"
            :label="getField('CONTACT_EMAIL').name"
            hide-details
            class="mb-4"
            outlined>
        </v-text-field>

        <v-text-field
            v-model="contact.phone"
            v-if="hasField('CONTACT_PHONE')"
            :label="getField('CONTACT_PHONE').name"
            hide-details
            class="mb-4"
            outlined>
        </v-text-field>

        <v-text-field
            v-model="contact.title"
            v-if="hasField('CONTACT_TITLE')"
            :label="getField('CONTACT_TITLE').name"
            hide-details
            class="mb-4"
            outlined>
        </v-text-field>

        <div v-if="hasFamilyElement('ContactFonction')" class="text-left mt-5">
            <label >
                {{ getField('ContactFonction').name }}
            </label>
            <v-autocomplete
                v-model="contact.profession"
                :items="getFamilyByCode('ContactFonction')"
                item-text="label"
                return-object
                outlined>
            </v-autocomplete>
        </div>

        <v-alert v-if="submitted && (contact.first_name === '' || contact.first_name === null)"
                 type="error"
                 class="mt-5 text-left">
            Le prénom est requis.
        </v-alert>

        <v-alert v-if="submitted && (contact.last_name === '' || contact.last_name === null)"
                 type="error"
                 class="mt-5 text-left">
            Le nom est requis.
        </v-alert>

        <v-alert v-if="submitted && (contact.email !== '' || contact.email !== null) && hasValidEmail(contact.email)"
                 type="error"
                 class="mt-5 text-left">
            Le format de l'e-mail est incorrect.
        </v-alert>

        <v-alert v-if="submitted && (contact.phone !== '' && contact.phone !== null) && hasValidPhone(contact.phone)"
                 type="error"
                 class="mt-5 text-left">
            Le format du numéro de téléphone est incorrect.
        </v-alert>

        <div class="text-center w-100 mt-3">
            <v-btn class="text-none"
                   @click="prepareAddContact"
                   v-if="!edit"
                   :color="primaryColor"
                   style="border-radius: 20px; color: white">
                Ajouter
            </v-btn>

            <v-btn class="text-none"
                   v-else
                   @click="saveContact"
                   :color="primaryColor"
                   style="border-radius: 20px; color: white">
                Enregistrer
            </v-btn>
        </div>
    </div>
</template>

<script>
import * as EmailValidator from 'email-validator'
import PhoneNumber from "awesome-phonenumber"
import {mapGetters, mapMutations, mapState} from "vuex"

export default {
    name: "ApidaeContactItem",
    props: ['contact', 'requiredField', 'edit', 'professions', 'index'],
    data() {
        return {
            selectedProfession: null,
            submitted: false
        }
    },
    methods: {
        ...mapMutations('web_form', ['updateContact', 'addContact']),
        prepareAddContact() {
            this.submitted = true

            if(this.contact.first_name !== null && this.contact.first_name !== '' &&
                this.contact.last_name !== null && this.contact.last_name !== '')
            {
                let contact = this.contact

                this.addContact(contact)

                this.$global.$emit('close-dialog')
            }
        },
        saveContact() {
            if(this.contact.first_name !== null && this.contact.first_name !== '' &&
                this.contact.last_name !== null && this.contact.last_name !== '')
            {
                let contact = this.contact

                this.updateContact([this.index, contact])
                this.$global.$emit('close-dialog')
            }
        },
        hasValidEmail(email) {
            return !EmailValidator.validate(email)
        },
        hasValidPhone(phone) {
            if(phone !== null) {
                let phoneFr = new PhoneNumber(phone, 'FR')
                let phoneNc = new PhoneNumber(phone, 'NC')
                let phoneCan = new PhoneNumber(phone, 'CA')

                return !(phoneFr.isValid() || phoneNc.isValid() || phoneCan.isValid())
            }
        }
    },
    computed: {
        ...mapState('web_form', ['disabled', 'provider']),
        ...mapState('webFormStyle', ['fontFamily', 'primaryColor', 'titlesColor', 'fieldsColor', 'backGroundColor']),
        ...mapGetters('web_form', ['hasField', 'hasFamilyElement', 'getFamilyByCode', 'getElementsByFamilyCode', 'getField']),
    },
    created() {
        this.selectedProfession = this.contact.profession

        this.$global.$on('reset-submitted', () => {
            this.submitted = false
        })
    },
    beforeDestroy() {
        this.$global.$off('reset-submitted')
    }
}
</script>